// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"625eaa041d54c8a6","5763":"de9d07748428e839","6893":"aab3be2e9d8dc913","6974":"6943141806dab038","7222":"5bb4735c3e9f6a4b","7937":"390604e799993a70"}[chunkId] + ".js";
};